<mat-checkbox [checked]="isChecked()" (change)="toggleCheck()">{{ value }}</mat-checkbox>
